export default function _heroBanner() {
    /**
     * Scroll button selector
     * @const {string}
     */
    const SCROLL_BTN_SELECTOR = '.hero-banner__js-scroll-btn';

    const AUTOCOMPLETE_SEARCH_INPUT =
        '.hero-banner-search__bar .hero-banner-search__input';

    const HERO_BANNER_FORM = '.hero-banner-search__form';

    const HERO_BANNER_SEARCH_HAS_INPUT = 'hero-banner-search__form--has-input';

    const HERO_BANNER_SEARCH_CLEAR = '.hero-banner-search__clear';

    const HERO_BANNER_SEARCH_CLEAR_HAS_INPUT =
        'hero-banner-search__clear--has-input';

    const AUTOCOMPLETE_SEARCH_LISTBOX =
        '.hero-banner-search__bar .autocomplete-search-listbox';

    // Add event listener to the scroll button
    function smpScrollTopBtn(selector) {
        // On click of the scroll button, scroll banner out of the way to expose main content
        selector.addEventListener('click', () => {
            selector.scrollIntoView({
                behavior: 'smooth',
            });
        });
    }

    function searchInputHasValue(input) {
        input.addEventListener('keyup', () => {
            if (input.value !== '') {
                document
                    .querySelector(HERO_BANNER_FORM)
                    .classList.add(HERO_BANNER_SEARCH_HAS_INPUT);
                document
                    .querySelector(HERO_BANNER_SEARCH_CLEAR)
                    .classList.add(HERO_BANNER_SEARCH_CLEAR_HAS_INPUT);
            } else {
                document
                    .querySelector(HERO_BANNER_FORM)
                    .classList.remove(HERO_BANNER_SEARCH_HAS_INPUT);
                document
                    .querySelector(HERO_BANNER_SEARCH_CLEAR)
                    .classList.remove(HERO_BANNER_SEARCH_CLEAR_HAS_INPUT);
            }
        });
    }

    function searchInputClear(button) {
        const input = document.querySelector(AUTOCOMPLETE_SEARCH_INPUT);
        button.addEventListener('click', () => {
            input.value = '';
            document
                .querySelector(HERO_BANNER_FORM)
                .classList.remove(HERO_BANNER_SEARCH_HAS_INPUT);
            document
                .querySelector(HERO_BANNER_SEARCH_CLEAR)
                .classList.remove(HERO_BANNER_SEARCH_CLEAR_HAS_INPUT);
            document.querySelector(AUTOCOMPLETE_SEARCH_LISTBOX).innerHTML = '';
        });
    }

    /**
     * @const {boolean}
     */
    const scrollBtnExists = !!document.querySelector(SCROLL_BTN_SELECTOR);
    // If the scollBtn Exists
    if (scrollBtnExists) {
        smpScrollTopBtn(document.querySelector(SCROLL_BTN_SELECTOR));
    }

    const autocompleteSearchExists = !!document.querySelector(
        AUTOCOMPLETE_SEARCH_INPUT
    );
    // If the input Exists
    if (autocompleteSearchExists) {
        searchInputHasValue(document.querySelector(AUTOCOMPLETE_SEARCH_INPUT));
    }

    const autocompleteClearExists = !!document.querySelector(
        HERO_BANNER_SEARCH_CLEAR
    );
    // If the input Exists
    if (autocompleteSearchExists && autocompleteClearExists) {
        searchInputClear(document.querySelector(HERO_BANNER_SEARCH_CLEAR));
    }
}

_heroBanner();
